import { Observable as n } from "@microsoft/fast-element";
class i {
  getSlots(e) {
    var t;
    return (t = e.shadowRoot) == null ? void 0 : t.querySelectorAll("slot");
  }
  addedCallback(e) {
    const t = this.getSlots(e.source);
    if (t.length === 0)
      return;
    const s = n.getNotifier(e.source);
    for (const o of t)
      s.subscribe(this, o.name);
    this.handleChange(e.source);
  }
  removedCallback(e) {
    const t = this.getSlots(e.source);
    if (t.length === 0)
      return;
    const s = n.getNotifier(e.source);
    for (const o of t)
      s.unsubscribe(this, o.name);
  }
}
function a(r) {
  return new class extends i {
    handleChange(e) {
      r(e);
    }
  }();
}
export {
  i as SlotBehavior,
  a as slotBehavior
};
